export function createImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener("load", () => resolve(img));
    img.addEventListener("error", (err) => reject(err));
    img.setAttribute("crossOrigin", "anonymous");
    img.src = url;
  });
}

export const DEFAULT_SITE_CONTENT = {
  pageAccess: {
    home: {
      status: "active",
      message: "Cette page est momentanément indisponible.",
    },
    latdior: {
      status: "active",
      message: "Cette page est momentanément indisponible.",
    },
    artistes: {
      status: "active",
      message: "Cette page est momentanément indisponible.",
    },
    news: {
      status: "active",
      message: "Cette page est momentanément indisponible.",
    },
    studio: {
      status: "active",
      message: "Cette page est momentanément indisponible.",
    },
    booking: {
      status: "active",
      message: "La réservation studio est momentanément indisponible.",
    },
    services: {
      status: "active",
      message: "Cette page est momentanément indisponible.",
    },
    videos: {
      status: "active",
      message: "Cette page est momentanément indisponible.",
    },
    contact: {
      status: "active",
      message: "Cette page est momentanément indisponible.",
    },
    login: {
      status: "active",
      message: "La connexion est momentanément indisponible.",
    },
    account: {
      status: "active",
      message: "L'espace utilisateur est momentanément indisponible.",
    },
    cart: {
      status: "active",
      message: "Le panier est momentanément indisponible.",
    },
    legal: {
      status: "active",
      message: "Cette page est momentanément indisponible.",
    },
  },
  visibility: {
    homeNewsHero: true,
    homeYms: true,
    homeSession: true,
    homeCovers: true,
    homeMerch: true,
    homeVideos: true,
    homeCtas: true,
    studioHero: true,
    studioServices: true,
    studioMethod: true,
    latdiorHero: true,
    latdiorStats: true,
    latdiorCollection: true,
    contactHero: true,
    contactCards: true,
    artistesSlides: true,
    artistesGallery: true,
    artistesCovers: true,
  },
  texts: {
    footerText: "",
    footer_instagram: "",
    footer_twitter: "",
    footer_youtube: "",
    footer_tiktok: "",
    ymsTitle: "YMS devoile son univers unique",
    ymsDescription:
      "C'est le 15 avril 2004 a Villeneuve-Saint-Georges que tout commence: YMS voit le jour. Il plonge dans la musique des 2014, comme beatmaker et inge son, forme par son pere Aumar Pulhosow, artiste et ex-membre du groupe Djolof signe chez Universal.",
    ymsButton: "Decouvrir",
    sessionTitle: "Unlimited Session",
    sessionDescription:
      "Unlimited Session, c'est une marque musicale, une mentalite, un mouvement. Un endroit ou la creation n'a aucune limite, ou l'on peut produire sans fin.",
    sessionButton1: "En savoir plus",
    sessionButton2: "Reserver",
  },
  typography: {},
  merch: [
    "/images/latdior1.png",
    "/images/latdior2.png",
    "/images/latdior3.png",
    "/images/latdior4.png",
    "/images/latdior5.png",
  ],
  merchLinks: ["/latdior#collection", "/latdior#collection", "/latdior#collection", "/latdior#collection", "/latdior#collection"],
  merchLabels: ["Voir / commander", "Voir / commander", "Voir / commander", "Voir / commander", "Voir / commander"],
  pages: {
    home: {
      ymsBadge: "Artiste",
      ymsButtonUrl: "/artistes",
      sessionLogo: "/images/logo.png",
      sessionButton1Url: "/studio",
      sessionButton2Url: "/reservation-studio",
      coversTitle: "Découvrez nos dernières pochettes",
      ctas: {
        contactTitle: "Vous cherchez quelque chose ?",
        contactDescription:
          "Besoin d'un devis, d'un mix, ou d'un renseignement rapide ? Écris-nous et on te répond vite.",
        contactLabel: "Nous écrire",
        contactUrl: "/contact",
        newsletterTitle: "Inscrivez-vous à notre newsletter !",
        newsletterDescription:
          "Reste informé des nouvelles sessions, sorties et offres du studio & label.",
        socialTitle: "Rejoignez-nous sur les réseaux !",
        socialDescription:
          "Suivez Unlimited Session pour découvrir nos dernières actus, artistes et sorties.",
        facebookUrl: "https://facebook.com",
        instagramUrl: "https://instagram.com",
        youtubeUrl: "https://youtube.com",
        twitterUrl: "https://twitter.com",
      },
      newsHero: {
        enabled: true,
        title: 'Nouveau single "7 vies" de YMS disponible',
        subtitle: "Découvre la nouvelle sortie de YMS.",
        mediaType: "video",
        video: "/videos/studio-video.mp4",
        fallbackImage: "/images/yms-full.png",
        watchUrl: "https://youtube.com",
        watchLabel: "Regarder",
        discoverUrl: "/news",
        discoverLabel: "Découvrir",
      },
      latdiorPreview: {
        eyebrow: "Latdior",
        title: "Collection Latdior",
        description:
          "Un aperçu de la capsule visible directement depuis l'accueil. Chaque visuel peut mener vers la page Latdior, une fiche produit ou un lien externe.",
        cardLabel: "Voir / commander",
        buttonLabel: "Découvrir Latdior",
        buttonUrl: "/latdior#collection",
        secondaryLabel: "Site officiel",
        secondaryUrl: "https://latdiorparis.com",
      },
    },
    news: {
      eyebrow: "Actualités",
      title: "Sorties, sessions, mouvements.",
      featuredEyebrow: "À la une",
      allNewsLabel: "Toutes les news",
      journalEyebrow: "Journal",
      journalTitle: "Les dernières news",
      useDefaultItems: true,
    },
    studio: {
      eyebrow: "Studio",
      title: "Un espace pour finir les morceaux, pas juste les commencer.",
      description:
        "Enregistrement, mixage, mastering, production et conseil artistique. Le studio est pense pour avancer vite, garder une vibe forte et sortir avec un son propre.",
      ctaLabel: "Reserver une session",
      ctaUrl: "/reservation-studio",
      bookingEnabled: true,
      paymentEnabled: false,
      privateMessage:
        "Le studio ne peut pas être réservé pour le moment, car il s'agit d'un studio privé.",
      heroVideo: "/videos/studio-video.mp4",
      heroImage: "/images/studio2.jpg",
      services: [
        {
          title: "Enregistrement",
          text: "Voix, toplines, prises rapides ou sessions longues avec une direction claire.",
          image: "/images/enregistrement.png",
          hidden: false,
        },
        {
          title: "Mix & mastering",
          text: "Equilibre, couleur, impact et export pret pour plateformes, clip ou showcase.",
          image: "/images/mixage.png",
          hidden: false,
        },
        {
          title: "Production",
          text: "Beatmaking, arrangements, choix sonores et accompagnement d'identite.",
          image: "/images/beatmaking.png",
          hidden: false,
        },
      ],
      methodTitle: "Simple, direct, efficace.",
      methodEyebrow: "Methode",
      methodSteps: [
        { title: "Brief", text: "Objectif, references, timing et direction.", hidden: false },
        { title: "Session", text: "Prises, choix, edit et decisions rapides.", hidden: false },
        { title: "Export", text: "Fichiers propres, versions et prochaines etapes.", hidden: false },
      ],
    },
    latdior: {
      badge: "Merch officiel",
      title: "Latdior",
      description:
        "Une capsule pensée comme une extension du son : silhouettes sombres, détails nets, énergie studio. Pas une boutique géante, un drop précis.",
      ctaLabel: "Me prevenir",
      ctaUrl: "/latdior#collection",
      secondaryLabel: "Voir la collection",
      drop: "Latdior 01",
      mood: "Noir, rouge, brut",
      status: "Bientôt disponible",
      products: [
        "/images/latdior1.png",
        "/images/latdior2.png",
        "/images/latdior3.png",
        "/images/latdior4.png",
        "/images/latdior5.png",
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "On lance la session ?",
      description:
        "Une idee, un morceau a finaliser, une cover a preparer ou une session a booker: ecris-nous avec le maximum de contexte et on te repond proprement.",
      email: "unlimitedsession@gmail.com",
      location: "Ile-de-France",
      heroImage: "/images/studio2.jpg",
      cards: [
        {
          title: "Reserver le studio",
          text: "Session enregistrement, mix, mastering ou direction artistique.",
          href: "/reservation-studio",
          label: "Reserver",
          hidden: false,
        },
        {
          title: "Projet artiste",
          text: "Clip, cover, sortie, accompagnement ou identite musicale.",
          href: "#contact-form",
          label: "Presenter le projet",
          hidden: false,
        },
        {
          title: "Collaboration",
          text: "Marque, evenement, label, media ou partenariat creatif.",
          href: "#contact-form",
          label: "Ouvrir la discussion",
          hidden: false,
        },
      ],
    },
  },
};

export function deepMerge(base, override) {
  if (!override || typeof override !== "object") return base;

  return Object.keys({ ...base, ...override }).reduce((acc, key) => {
    const baseValue = base ? base[key] : undefined;
    const overrideValue = override[key];

    if (Array.isArray(baseValue) || Array.isArray(overrideValue)) {
      acc[key] = Array.isArray(overrideValue) ? overrideValue : baseValue || [];
      return acc;
    }

    if (
      baseValue &&
      overrideValue &&
      typeof baseValue === "object" &&
      typeof overrideValue === "object"
    ) {
      acc[key] = deepMerge(baseValue, overrideValue);
      return acc;
    }

    acc[key] = overrideValue !== undefined ? overrideValue : baseValue;
    return acc;
  }, {});
}

export function mergeSiteContent(data) {
  return deepMerge(DEFAULT_SITE_CONTENT, data || {});
}

export function isPublicPageListed(site, pageKey) {
  return site?.pageAccess?.[pageKey]?.status !== "deleted";
}
